import React from 'react';

import { ConstantPermissions } from 'contexts/useConstant';
import InvoiceSharedFile from './InvoiceSharedFile';

export default function InvoiceProvider() {
  return (
    <InvoiceSharedFile
      title="Listado de facturas de proveedores"
      excelName="Facturas-de-proveedores"
      originType="P"
      permission={{
        store: ConstantPermissions.PURCH_PURCHASES_PROVIDER_INDEX,
        update: ConstantPermissions.PURCH_PURCHASES_PROVIDER_INDEX
      }}
    />
  );
}
